import {
    GET_USER,
    GET_QUALIFICATION_CATEGORIES,
    SET_UPDATED_QUAL_INFO,
    SET_UPDATED_PROFILE_INFO,
    SET_SINGLE_PROFILE_VALUE,
    GET_ALL_USERS,
    GET_PROFILE,
    GET_LOGGED_UID,
    UPDATE_SELECTED_USER_PASSWORD,
    GET_USERTYPES,
    GET_DEPARTMENTS,
    GET_AREAS,
    GET_USER_JOBPACKS
} from "./types";
import { SET_SNACKBAR_STATE } from "../QualificationsManager/types";

const INITIAL_STATE = {
    requesting: false,
    user: false,
    qualificationCategories: false,
    posting: false,
    postSuccess: false,
    allUsers: false,
    postFail: false,
    profile: false,
    departments: false,
    areas: false,
    usertypes: false,
    userJobpacks: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_USER.REQUEST: {
            return { ...state, requesting: true, user: false };
        }
        case GET_USER.FAIL: {
            return { ...state, requesting: false, user: false };
        }
        case GET_USER.SUCCESS: {
            return { ...state, requesting: false, user: action.payload };
        }
        case GET_PROFILE.REQUEST: {
            return { ...state, requesting: true, user: false, profile: false };
        }
        case GET_PROFILE.FAIL: {
            return { ...state, requesting: false, user: false, profile: false };
        }
        case GET_PROFILE.SUCCESS: {
            return {
                ...state,
                requesting: false,
                user: action.payload,
                profile: action.payload,
            };
        }
        case GET_LOGGED_UID.REQUEST: {
            return { ...state, requesting: true, loggedUID: false };
        }
        case GET_LOGGED_UID.FAIL: {
            return { ...state, requesting: false, loggedUID: false };
        }
        case GET_LOGGED_UID.SUCCESS: {
            return { ...state, requesting: false, loggedUID: action.payload };
        }
        case GET_QUALIFICATION_CATEGORIES.REQUEST: {
            return {
                ...state,
                requesting: true,
                qualificationCategories: false,
            };
        }
        case GET_QUALIFICATION_CATEGORIES.FAIL: {
            return {
                ...state,
                requesting: false,
                qualificationCategories: false,
            };
        }
        case GET_QUALIFICATION_CATEGORIES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                qualificationCategories: action.payload,
            };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload,
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload,
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        case SET_UPDATED_QUAL_INFO.REQUEST: {
            return {
                ...state,
                requesting: true,
                posting: true,
                postSuccess: false,
                postFail: false,
            };
        }
        case SET_UPDATED_QUAL_INFO.FAIL: {
            return {
                ...state,
                requesting: false,
                posting: false,
                postSuccess: false,
                postFail: true,
            };
        }
        case SET_UPDATED_QUAL_INFO.SUCCESS: {
            return {
                ...state,
                requesting: false,
                posting: false,
                postSuccess: true,
                postFail: false,
            };
        }
        case SET_UPDATED_PROFILE_INFO.REQUEST: {
            return {
                ...state,
                requesting: true,
                posting: true,
                postSuccess: false,
                postFail: false,
            };
        }
        case SET_UPDATED_PROFILE_INFO.FAIL: {
            return {
                ...state,
                requesting: false,
                posting: false,
                postSuccess: false,
                postFail: true,
            };
        }
        case SET_UPDATED_PROFILE_INFO.SUCCESS: {
            return {
                ...state,
                requesting: false,
                posting: false,
                postSuccess: true,
                postFail: false,
            };
        }
        case SET_SINGLE_PROFILE_VALUE.REQUEST: {
            return {
                ...state,
                posting: true,
                requesting: true,
                postSuccess: false,
                postFail: false,
            };
        }
        case SET_SINGLE_PROFILE_VALUE.FAIL: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: false,
                postFail: true,
            };
        }
        case SET_SINGLE_PROFILE_VALUE.SUCCESS: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: true,
                postFail: false,
            };
        }
        case SET_SNACKBAR_STATE: {
            return {
                ...state,
                postSuccess: action.payload,
                postFail: action.payload,
            };
        }
        case GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, allUsers: false };
        }
        case GET_ALL_USERS.FAIL: {
            return { ...state, requesting: false, allUsers: false };
        }
        case GET_ALL_USERS.SUCCESS: {
            return { ...state, requesting: false, allUsers: action.payload };
        }
        case UPDATE_SELECTED_USER_PASSWORD.REQUEST: {
            return {
                ...state,
                requesting: true,
                posting: true,
                postFail: false,
                postSuccess: false,
            };
        }
        case UPDATE_SELECTED_USER_PASSWORD.FAIL: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postFail: true,
                postSuccess: false,
            };
        }
        case UPDATE_SELECTED_USER_PASSWORD.SUCCESS: {
            return {
                ...state,
                requesting: false,
                posting: false,
                postFail: false,
                postSuccess: true,
            };
        }
        case GET_USERTYPES.REQUEST: {
            return { ...state, requesting: true, usertypes: false };
        }
        case GET_USERTYPES.SUCCESS: {
            return { ...state, requesting: false, usertypes: action.payload };
        }
        case GET_USERTYPES.FAIL: {
            return { ...state, requesting: false, usertypes: false };
        }
        //User Jobpacks
        case GET_USER_JOBPACKS.REQUEST: {
            return { ...state, requesting: true, userJobpacks: false };
        }
        case GET_USER_JOBPACKS.SUCCESS: {
            return { ...state, requesting: false, userJobpacks: action.payload };
        }
        case GET_USER_JOBPACKS.FAIL: {
            return { ...state, requesting: false, userJobpacks: false };
        }
        
        default: {
            return state;
        }
    }
};
